var deepCopy = function (obj) {
    var copyObj = Array.isArray(obj) ? [] : {};
    for (var key in obj) {
        if (typeof obj[key] === 'object' && obj[key]) {
            copyObj[key] = deepCopy(obj[key]);
        }
        else {
            copyObj[key] = obj[key];
        }
    }
    return copyObj;
};

export { deepCopy };
